import type { Map as MapLibreMap } from 'maplibre-gl';

/** MapLibre draws to a canvas, so nothing it renders reaches the DOM and no
 *  assertion can tell a drawn map from an empty one. The instance is therefore
 *  attached to the element that owns it, which keeps the seam scoped to that
 *  element rather than putting a map on `window` for the whole application. */
type MapElement = HTMLElement & { __map?: MapLibreMap };

export const attachMapToElement = (element: HTMLElement | null, map: MapLibreMap) => {
    if (element) (element as MapElement).__map = map;
};

export const mapOfElement = (element: Element | null): MapLibreMap | undefined => (element as MapElement | null)?.__map;
